export const PASSWORD_RESET = 'AUTH/PASSWORD_RESET';
export const PASSWORD_RESET_PENDING = `${PASSWORD_RESET}_PENDING`;
export const PASSWORD_RESET_FULFILLED = `${PASSWORD_RESET}_FULFILLED`;
export const PASSWORD_RESET_REJECTED = `${PASSWORD_RESET}_REJECTED`;

export const resetPassword = (password) => ({
  type: PASSWORD_RESET,
  password,
});
